import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { createContext } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from '../Carousel.module.scss.js';

const { elementTestLabel } = getTestLabels('Carousel');
const SlideContext = createContext({ isSelected: false });
const SlideWrap = (props) => {
    const { children, isSelected = false, onSlideClick, ...otherProps } = props;
    return (jsx(SlideContext.Provider, { value: { isSelected }, children: jsx("div", { "data-zta": elementTestLabel('SlideWrapOuter'), ...otherProps, className: style['z-carousel-beta-slide-wrap'], children: jsx("div", { "data-zta": elementTestLabel('SlideWrapInner'), onClick: onSlideClick, className: classNames(style['z-carousel-beta-slide-wrap-inner']), children: children }) }) }));
};

export { SlideContext, SlideWrap };
//# sourceMappingURL=SlideWrap.js.map
